import React, { useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import FloatingButton from "./components/FloatingButton/FloatingButton";
import Error404Page from "./components/Error404Page/Error404Page";

import IndexPage from "./pages/IndexPage/IndexPage";
import BasicPace from "./pages/BasicPace/BasicPace";
import WanjinshiMarathon from "./pages/WanjinshiMarathon/WanjinshiMarathon";
import NagoyaMarathon from "./pages/NagoyaMarathon/NagoyaMarathon";
import Scbmarathon from "./pages/Scbmarathon/Scbmarathon";
import TaipeiMarathon from "./pages/TaipeiMarathonTimer/TaipeiMarathon";
import ExpoCupon from "./pages/ExpoCupon/ExpoCupon";
import AboutMaoMao from "./pages/AboutMaoMao/AboutMaoMao";
import AboutMarathonTimer from "./pages/AboutMarathonTimer/AboutMarathonTimer";
import Osaka2025 from "./pages/2025Osaka/Osaka2025";
import Tokyo2025 from "./pages/2025Tokyo/Tokyo2025";
import GroupRegistration from "./pages/GroupRegistration/GroupRegistration";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App() {
    return (
        <Router>
            <div className="App">
                <div className="top-page">
                    <Header />
                    <main>
                        <Routes>
                            <Route path="/" element={<IndexPage />} />
                            <Route path="/Basic" element={<BasicPace />} />
                            <Route path="/Osaka2025" element={<Osaka2025 />} />
                            <Route path="/Tokyo2025" element={<Tokyo2025 />} />
                            <Route path="/WanjinshiMarathon" element={<WanjinshiMarathon />} />
                            <Route path="/NagoyaMarathon" element={<NagoyaMarathon />} />
                            <Route path="/Scbmarathon" element={<Scbmarathon />} />
                            <Route path="/TaipeiMarathon" element={<TaipeiMarathon />} />
                            <Route
                                path="/AboutMarathonTimer"
                                element={<AboutMarathonTimer />}
                            />
                            <Route path="/ExpoCupon" element={<ExpoCupon />} />
                            <Route path="/AboutMaoMao" element={<AboutMaoMao />} />
                            <Route path="/GroupRegistration" element={<GroupRegistration />} />
                            <Route path="*" element={<Error404Page />} />
                        </Routes>
                        <ScrollToTop />
                    </main>
                    <Footer />
                    <FloatingButton />
                </div>
            </div>
        </Router>
    );
}

export default App;
